import { apiServerRoutes } from '../constants/apiRoutes'
import { getAPICallServer } from '../utils/axios.util'

class InsuranceService {
  fetch(req: any) {
    return getAPICallServer(apiServerRoutes.FETCH_INSURANCE, req)
  }
}

export default new InsuranceService()
